/**
 * The global search shows at most this many events, upcoming ones taking precedence
 * over past ones.
 */
export const programPackageSearchLimit = 10;

function eventFormatLanguageFilter(locale) {
    return locale === 'de'
        ? '(event_format_language="de" OR event_format_language="en")'
        : 'event_format_language="en"';
}

/**
 * Events are looked up with two queries instead of one so that upcoming events can be
 * ranked ahead of past ones: Meilisearch sorts a single result set as a whole, which
 * would interleave both. Each query is ordered by the date closest to now first.
 *
 * @param {string} query
 * @param {string} locale
 * @param {number} [timestamp] Seconds since the epoch, matching the indexed `end_date`.
 * @returns {Array<{indexName: string, query: string, params: {filters: string, hitsPerPage: number}}>}
 */
export function useProgramPackageSearchQueries(query, locale, timestamp = Math.floor(Date.now() / 1000)) {
    const languageFilter = eventFormatLanguageFilter(locale);

    return [
        {
            indexName: 'program_packages:start_date:asc',
            query,
            params: {
                filters: `${languageFilter} AND end_date >= ${timestamp}`,
                hitsPerPage: programPackageSearchLimit,
            },
        },
        {
            indexName: 'program_packages:start_date:desc',
            query,
            params: {
                filters: `${languageFilter} AND end_date < ${timestamp}`,
                hitsPerPage: programPackageSearchLimit,
            },
        },
    ];
}

/**
 * Fills the section up with past events only as far as the upcoming ones leave room.
 *
 * @param {Array<Array<object>>} hits The hits of every query, in the order they were sent.
 * @returns {Array<object>}
 */
export function useProgramPackageSearchHits([upcomingHits = [], pastHits = []] = []) {
    return [...upcomingHits, ...pastHits].slice(0, programPackageSearchLimit);
}
